import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { Result } from '../Result';
import type { IMultiplePropagationConstraint } from '../../../stores/model/metamodel/multiple_propagation_constraint';

/**
 * Check if the parent object contains another MPC with the same type and the
 * same paths.
 */
class MPCDuplicateCheck extends Check<IMultiplePropagationConstraint> {
  static description = 'Check for duplicate multiple propagation constraints';

  check(): Report {
    this.report = new Report();

    const mpc = this.element;

    for (const other of mpc.objectType.multiplePropagationConstraints) {
      if (mpc !== other && mpc.equals(other)) {
        this.report.addMessage(
          MessageType.ERROR,
          'Duplicate multiple propagation constraint found.',
          this,
          this.element
        );
      }
    }

    if (this.report.result === Result.NO_RESULT) {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No duplicate multiple propagation constraints found.',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default MPCDuplicateCheck;
